var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn', 'btn-primary', {'btn-cta': _vm.type === 'cta'}],attrs:{"onclick":_vm.adRollPixel ? ("adRollEvent('" + _vm.adRollPixel + "')") : '',"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }